import React, { useState, useEffect, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import StockDiscountCategoryService from "../../Controller/StockDiscountCategoryController";
import { ThemeContext } from "../../../Layout/Theme/ThemeContext";


function CreateSupplierHistory({ modalInstance, currentStockDiscountCategory, onClose, onSuccess, DiscountTypeList, PartID }) {
    const { theme, toggleTheme } = useContext(ThemeContext);
    let accordTheme = theme === "dark" ? "accordion-header-dark" : "accordion-header-light";

    const [formData, setFormData] = useState({
        ID: 0, FK_Stock_ID: PartID, FK_Stock_Category_ID: 0
    });
    const navigate = useNavigate();
    const [errors, setErrors] = useState({});

    useEffect(() => {
        if (currentStockDiscountCategory) {
            setFormData({
                ID: currentStockDiscountCategory.ID, FK_Stock_ID: PartID, FK_Stock_Category_ID: currentStockDiscountCategory.FK_Stock_Category_ID
            });
        } else {
            setFormData({
                ID: 0, FK_Stock_ID: PartID, FK_Stock_Category_ID: 0
            });
        }
    }, [currentStockDiscountCategory]);

    const handleFieldChange = (event) => {
        debugger;
        const { name, value } = event.target;
        setFormData({
            ...formData,
            [name]: parseInt(value),
        });
    };

    const handleFormSubmit = async (event) => {
        event.preventDefault();

        if (currentStockDiscountCategory) {
            formData.ID = currentStockDiscountCategory.ID;

        } else {
            formData.ID = 0;

        }
        debugger;
        await StockDiscountCategoryService.CreateStockDiscountCategory(event, formData);
        onSuccess();

    };


    return (
        <div>
            <form onSubmit={handleFormSubmit}>
                <div className="modal fade stockDiscountModal show d-block" id="stockDiscountModal" tabIndex="-1" aria-labelledby="stockDiscountModalLabel" aria-hidden="true" data-backdrop="static">

                    <div className="modal-dialog modal-lg">
                        <div className="modal-content">
                            <div className={`modal-header ${accordTheme}`}>
                                <h5 className="modal-title" id="largeModalLabel">{currentStockDiscountCategory ? "Edit Discount" : "Add Discount"}</h5>
                                <button type="button" className="close" aria-label="Close" onClick={onClose}>
                                    <span aria-hidden="true">&times;</span>
                                </button>
                            </div>
                            <div className="modal-body">
                                <div className="row mb-3" style={{ "marginLeft": "10px", "marginTop": "10px" }}>
                                    <label htmlFor="DiscountTypeID" className="col-sm-2 col-form-label">Discount Categories</label>
                                    <div className="col-sm-4">
                                        <select
                                            name="FK_Stock_Category_ID"
                                            className='form-control'
                                            value={formData.FK_Stock_Category_ID}
                                            onChange={handleFieldChange}
                                        >
                                            <option value="0">Select Discount Categories</option>
                                            {DiscountTypeList.map((discount) => (
                                                <option key={discount.PK_StockCategory_ID} value={discount.PK_StockCategory_ID}>
                                                    {discount.vc_Name}
                                                </option>
                                            ))}
                                        </select>
                                    </div>
                                </div>



                            </div>

                            <div className="modal-footer">
                                <button type="submit" className="btn btn-primary">
                                    <img src="assets/img/resources/update-icon.png" alt="Add icon" style={{ height: "10px" }} /> {currentStockDiscountCategory ? " Update" : " Save"}
                                </button>
                                <button className="btn btn-danger" type="button" aria-label="Close" onClick={onClose}>
                                    <img src="assets/img/resources/close-button-icon.png" alt="Add icon" style={{ height: "10px" }} /> Close
                                </button>
                            </div>

                        </div>
                    </div>
                </div>
            </form>
        </div>
    );
}
export default CreateSupplierHistory;
